// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Image-space1-s0jNJ {
	margin-bottom: 6px !important;
}

.Image-space2-XJLGm {
	margin-bottom: 12px !important;
}

.Image-space3-VuHyT {
	margin-bottom: 18px !important;
}

.Image-space4-rA3i5 {
	margin-bottom: 24px !important;
}

.Image-space5-xDUPN {
	margin-bottom: 30px !important;
}

.Image-space6-_rWhv {
	margin-bottom: 36px !important;
}

.Image-space7-jWRm1 {
	margin-bottom: 42px !important;
}

.Image-spaceTop8-_utP8 {
	margin-bottom: 48px !important;
}

.Image-spaceTop1-V8AMN {
	margin-top: 6px !important;
}

.Image-spaceTop2-vZw5u {
	margin-top: 12px !important;
}

.Image-spaceTop3-_3ZwZ {
	margin-top: 18px !important;
}

.Image-spaceTop4-vtazz {
	margin-top: 24px !important;
}

.Image-spaceTop5-pwEdZ {
	margin-top: 30px !important;
}

.Image-spaceTop6-xzEBF {
	margin-top: 36px !important;
}

.Image-spaceTop7-dxWQT {
	margin-top: 42px !important;
}

.Image-spaceTop8-_utP8 {
	margin-top: 48px !important;
}

.Image-noMargin-VAnBM {
	margin: 0px !important;
}

.Image-padding1-N_llk {
	padding-bottom: 6px !important;
}

.Image-padding2-_WkBQ {
	padding-bottom: 12px !important;
}

.Image-padding3-WIQ7C {
	padding-bottom: 18px !important;
}

.Image-padding4-kggW_ {
	padding-bottom: 24px !important;
}

.Image-padding5-BkYL6 {
	padding-bottom: 30px !important;
}

.Image-padding6-QfR0Y {
	padding-bottom: 36px !important;
}

.Image-padding7-S7E0z {
	padding-bottom: 42px !important;
}

.Image-paddingTop1-S0DqA {
	padding-top: 6px !important;
}

.Image-paddingTop2-qUAB0 {
	padding-top: 12px !important;
}

.Image-paddingTop3-U23ro {
	padding-top: 18px !important;
}

.Image-paddingTop4-LYbl7 {
	padding-top: 24px !important;
}

.Image-paddingTop5-X63fh {
	padding-top: 30px !important;
}

.Image-paddingTop6-Grhem {
	padding-top: 36px !important;
}

.Image-paddingTop7-XGRil {
	padding-top: 42px !important;
}

.Image-noPadding-_jqMq {
	padding: 0px !important;
}

.Image-textBold-pgv7p {
	font-weight: 500 !important;
}

.Image-textBolder-OO13Y {
	font-weight: 700 !important;
}

.Image-textNormal-CPwZQ {
	font-weight: normal !important;
}

.Image-spaceBottom20-QDkGF {
	margin-bottom: 20px;
}

.Image-spaceBottom10-vrFC7 {
	margin-bottom: 10px;
}

.Image-marginNone-ebekk {
	margin: 0;
}

.Image-spaceBottom15-KxaxO {
	margin-bottom: 15px;
}

.Image-marginTopNone-tZB_g {
	margin-top: 0;
}

.Image-spaceTop11-SFdQP {
	margin-top: 11px;
}

.Image-spaceTop21-YGUaf {
	margin-top: 21px;
}

.Image-spaceTop20-Iy5yJ {
	margin-top: 20px;
}

.Image-spaceTop10-v55_O {
	margin-top: 10px;
}

/*New Design Text Colors */

.Image-textDarkBlue-It0pt {
	color: rgb(20, 39, 94) !important;
}

.Image-textLightBlue-rVVdr {
	color: rgb(57, 87, 106) !important;
}

.Image-textLightSandleGreen-yPzSK {
	color: rgb(76, 86, 41) !important;
}

.Image-textLightBrown-haeMY {
	color: rgb(115, 79, 33) !important;
}

.Image-textMediumMaroon-tFMax {
	color: rgb(87, 37, 51) !important;
}

.Image-textBrown-ezaxq {
	color: rgb(160, 47, 24) !important;
}

.Image-textMaroon-wVao7 {
	color: rgb(155, 49, 67) !important;
}

.Image-textDarkBrown-rTlpP {
	color: rgb(83, 18, 16) !important;
}

.Image-textMediumBrown-lWh1j {
	color: rgb(142, 28, 10) !important;
}

.Image-textSkyBlue-J7lAn {
	color: rgb(37, 117, 141) !important;
}

.Image-textGray-_U3XH {
	color: rgb(77, 65, 51) !important;
}

.Image-commonHeaderAdmin-WPpD3 {
	position: fixed !important;
}

.Image-adminLayout-qw9uv {
	padding-top: 64px !important;
}

.Image-box-qJ7m1 h2 {
	font-size: 21px;
	font-weight: 600;
}

.Image-exportLink-B3KOQ {
	margin-bottom: -29px;
}

.Image-blockCenter-WQ6bX {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.Image-panelHeader-rc6l5 {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.Image-currencyselect-qSPOw {
	width: 100%;
	margin-right: 0px;
}

.Image-panelHeader-rc6l5 {
	overflow: hidden;
	position: relative;
}

.Image-mar0-oKlly {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.Image-blockCenter-WQ6bX {
		padding: 0px;
	}

	.Image-panelHeader-rc6l5 {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.Image-sideAdminPageWrapper-tHNAt {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.Image-panelHeader-rc6l5 {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.Image-table-dbFoT {
	display: table;
}

.Image-tableRow-Gcp7m {
	display: table-row;
}

.Image-tableCell-lWrwY {
	display: table-cell;
	float: none;
}

.Image-formGroup-lhsUW {
	margin-bottom: 6px;
}

.Image-select-NIbRz {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.Image-noMargin-VAnBM {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.Image-exportLink-B3KOQ {
	padding-top: 10px;
	padding-right: 10px;
}

.Image-labelTextNew-l8R5F {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.Image-displayInline-j69_C {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.Image-btnUPdate-dLljo {
	display: inline-block;
}

.Image-btnModalDelete-UuT9A {
	display: inline-block;
	margin-left: 15px;
}

.Image-radioBtn-q3Y4S {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.Image-backgroundImg-ZreLS {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.Image-btnUPdate-dLljo {
		display: block;
		margin-bottom: 12px;
	}

	.Image-btnModalDelete-UuT9A {
		display: block;
		margin-left: 0px;
	}

	.Image-btnWidth-dgDXs {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.Image-bannerImageBg-bI9Fo {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.Image-bannerDelete-XmvFH {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.Image-modalRoot-BWtHC {
	padding: 32px;
}

.Image-modalBorderBottom-MTrYZ {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.Image-logInModalBody-Az0Xf {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.Image-exportSection-afBtG {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.Image-exportSectionGridSub-qEE9P {
	grid-template-columns: 50% 49% !important;
}

.Image-exportText-z2KCz {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.Image-exportLinkImg-gEkhl {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.Image-vtrMiddle-fw46I {
	vertical-align: middle;
}

.Image-exportImg-OPs_M {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.Image-profileViewlabel-DpelH {
	display: inline-block;
	width: 38%
}

.Image-profileViewMainContent-iPi4P {
	display: inline-block;
	width: 62%;
}

.Image-profileViewMain-M7yzT {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.Image-profileViewInner-E12dQ {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.Image-profileImageSection-_YGdn {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.Image-lastviewInner-FJw6U {
	padding: 10px;
}

.Image-whyHostHoriLine-wilHJ {
	margin: 30px 0;
}

.Image-tableGrid-qrD0J {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.Image-headingContent-rE2V1 {
	font-size: 18px;
	font-weight: 500;
}

.Image-refundTextColor-Mh7c2 {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.Image-dividerLine-LH746 {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.Image-smallContent-v8rEQ {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.Image-sideAdminPageWrapper-tHNAt {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.Image-sideAdminPageWrapper-tHNAt {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.Image-exportSection-afBtG {
		grid-template-columns: 100%;
	}

	.Image-exportSectionGridSub-qEE9P {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.Image-profileViewlabel-DpelH {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.Image-profileViewMainContent-iPi4P {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.Image-ChangeToUpperCase-i_raY {
	text-transform: uppercase
}

.Image-noBorder-HeZ_I {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.Image-siteAdminHeading-RzIHp {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.Image-siteAdminSubHeading-rjA2t {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.Image-adminFormDivider-f0H0O {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5NA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `Image-space1-s0jNJ`,
	"space2": `Image-space2-XJLGm`,
	"space3": `Image-space3-VuHyT`,
	"space4": `Image-space4-rA3i5`,
	"space5": `Image-space5-xDUPN`,
	"space6": `Image-space6-_rWhv`,
	"space7": `Image-space7-jWRm1`,
	"spaceTop8": `Image-spaceTop8-_utP8`,
	"spaceTop1": `Image-spaceTop1-V8AMN`,
	"spaceTop2": `Image-spaceTop2-vZw5u`,
	"spaceTop3": `Image-spaceTop3-_3ZwZ`,
	"spaceTop4": `Image-spaceTop4-vtazz`,
	"spaceTop5": `Image-spaceTop5-pwEdZ`,
	"spaceTop6": `Image-spaceTop6-xzEBF`,
	"spaceTop7": `Image-spaceTop7-dxWQT`,
	"noMargin": `Image-noMargin-VAnBM`,
	"padding1": `Image-padding1-N_llk`,
	"padding2": `Image-padding2-_WkBQ`,
	"padding3": `Image-padding3-WIQ7C`,
	"padding4": `Image-padding4-kggW_`,
	"padding5": `Image-padding5-BkYL6`,
	"padding6": `Image-padding6-QfR0Y`,
	"padding7": `Image-padding7-S7E0z`,
	"paddingTop1": `Image-paddingTop1-S0DqA`,
	"paddingTop2": `Image-paddingTop2-qUAB0`,
	"paddingTop3": `Image-paddingTop3-U23ro`,
	"paddingTop4": `Image-paddingTop4-LYbl7`,
	"paddingTop5": `Image-paddingTop5-X63fh`,
	"paddingTop6": `Image-paddingTop6-Grhem`,
	"paddingTop7": `Image-paddingTop7-XGRil`,
	"noPadding": `Image-noPadding-_jqMq`,
	"textBold": `Image-textBold-pgv7p`,
	"textBolder": `Image-textBolder-OO13Y`,
	"textNormal": `Image-textNormal-CPwZQ`,
	"spaceBottom20": `Image-spaceBottom20-QDkGF`,
	"spaceBottom10": `Image-spaceBottom10-vrFC7`,
	"marginNone": `Image-marginNone-ebekk`,
	"spaceBottom15": `Image-spaceBottom15-KxaxO`,
	"marginTopNone": `Image-marginTopNone-tZB_g`,
	"spaceTop11": `Image-spaceTop11-SFdQP`,
	"spaceTop21": `Image-spaceTop21-YGUaf`,
	"spaceTop20": `Image-spaceTop20-Iy5yJ`,
	"spaceTop10": `Image-spaceTop10-v55_O`,
	"textDarkBlue": `Image-textDarkBlue-It0pt`,
	"textLightBlue": `Image-textLightBlue-rVVdr`,
	"textLightSandleGreen": `Image-textLightSandleGreen-yPzSK`,
	"textLightBrown": `Image-textLightBrown-haeMY`,
	"textMediumMaroon": `Image-textMediumMaroon-tFMax`,
	"textBrown": `Image-textBrown-ezaxq`,
	"textMaroon": `Image-textMaroon-wVao7`,
	"textDarkBrown": `Image-textDarkBrown-rTlpP`,
	"textMediumBrown": `Image-textMediumBrown-lWh1j`,
	"textSkyBlue": `Image-textSkyBlue-J7lAn`,
	"textGray": `Image-textGray-_U3XH`,
	"commonHeaderAdmin": `Image-commonHeaderAdmin-WPpD3`,
	"adminLayout": `Image-adminLayout-qw9uv`,
	"box": `Image-box-qJ7m1`,
	"exportLink": `Image-exportLink-B3KOQ`,
	"blockCenter": `Image-blockCenter-WQ6bX`,
	"panelHeader": `Image-panelHeader-rc6l5`,
	"currencyselect": `Image-currencyselect-qSPOw`,
	"mar0": `Image-mar0-oKlly`,
	"sideAdminPageWrapper": `Image-sideAdminPageWrapper-tHNAt`,
	"table": `Image-table-dbFoT`,
	"tableRow": `Image-tableRow-Gcp7m`,
	"tableCell": `Image-tableCell-lWrwY`,
	"formGroup": `Image-formGroup-lhsUW`,
	"select": `Image-select-NIbRz`,
	"labelTextNew": `Image-labelTextNew-l8R5F`,
	"displayInline": `Image-displayInline-j69_C`,
	"btnUPdate": `Image-btnUPdate-dLljo`,
	"btnModalDelete": `Image-btnModalDelete-UuT9A`,
	"radioBtn": `Image-radioBtn-q3Y4S`,
	"backgroundImg": `Image-backgroundImg-ZreLS`,
	"btnWidth": `Image-btnWidth-dgDXs`,
	"bannerImageBg": `Image-bannerImageBg-bI9Fo`,
	"bannerDelete": `Image-bannerDelete-XmvFH`,
	"modalRoot": `Image-modalRoot-BWtHC`,
	"modalBorderBottom": `Image-modalBorderBottom-MTrYZ`,
	"logInModalBody": `Image-logInModalBody-Az0Xf`,
	"exportSection": `Image-exportSection-afBtG`,
	"exportSectionGridSub": `Image-exportSectionGridSub-qEE9P`,
	"exportText": `Image-exportText-z2KCz`,
	"exportLinkImg": `Image-exportLinkImg-gEkhl`,
	"vtrMiddle": `Image-vtrMiddle-fw46I`,
	"exportImg": `Image-exportImg-OPs_M`,
	"profileViewlabel": `Image-profileViewlabel-DpelH`,
	"profileViewMainContent": `Image-profileViewMainContent-iPi4P`,
	"profileViewMain": `Image-profileViewMain-M7yzT`,
	"profileViewInner": `Image-profileViewInner-E12dQ`,
	"profileImageSection": `Image-profileImageSection-_YGdn`,
	"lastviewInner": `Image-lastviewInner-FJw6U`,
	"whyHostHoriLine": `Image-whyHostHoriLine-wilHJ`,
	"tableGrid": `Image-tableGrid-qrD0J`,
	"headingContent": `Image-headingContent-rE2V1`,
	"refundTextColor": `Image-refundTextColor-Mh7c2`,
	"dividerLine": `Image-dividerLine-LH746`,
	"smallContent": `Image-smallContent-v8rEQ`,
	"ChangeToUpperCase": `Image-ChangeToUpperCase-i_raY`,
	"noBorder": `Image-noBorder-HeZ_I`,
	"siteAdminHeading": `Image-siteAdminHeading-RzIHp`,
	"siteAdminSubHeading": `Image-siteAdminSubHeading-rjA2t`,
	"adminFormDivider": `Image-adminFormDivider-f0H0O`
};
module.exports = ___CSS_LOADER_EXPORT___;
